<template>
  <div id="app">
    <Nav v-if="isLoggedIn"/>
    <router-view/>
  </div>
</template>

<script>

import Nav from "./components/Nav";

export default {
  name: 'App',
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn
    },
  },
  components: {Nav}, mounted() {

  }

}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Fira+Sans+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

#app {
  font-family: 'Fira Sans Condensed', sans-serif;
  color: #2c3e50;
}

ul, li {
  list-style: none;
}
.analytics-count>.analytics-count__content:nth-of-type(2) .data-table-table{max-height: revert;}
.data-table{grid-template-columns:none!important;}
.data-table-pagination>:first-child{margin:10px 10px 10px 0!important;}
.data-table-pagination .pagination{margin:10px 10px 10px 0!important;}
.column.sortable{z-index: 1;}
</style>
